import React, { useState, useEffect, useRef } from "react";
import { Image } from "../../components/componentIndex";
import CancelIcon from "../../assets/images/doctorProfile/close-icon.svg";
import medications from '../../services/staticMedications'; // Assuming staticMedications is an array
import { CheckedImage } from "common/commonIndex";

const Chip = ({ type, placeholderName, onChange, list, setSearchMedicationsList, setIsSetDefault, isDisabled, searchList, selectedNoneValue,isInputClear }) => {
    const [inputValue, setInputValue] = useState(selectedNoneValue ? selectedNoneValue : ""); // Input value for new chip
    const [filteredData, setFilteredData] = useState([]); // Hold the filtered data (not necessary anymore as we use displayedData directly)
    const [displayedData, setDisplayedData] = useState([]); // This state holds the items to display in the dropdown
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const inputRef = useRef(null); // Ref for detecting clicks outside

    const ITEMS_PER_PAGE = 10;
    useEffect(() => {
        if (selectedNoneValue && selectedNoneValue !== '') {
            setInputValue(selectedNoneValue);
        }
    }, [selectedNoneValue])

    // Handle click outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (inputRef.current && !inputRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Add a chip when the user presses Enter
    const handleKeyDown = (e) => {
        if (e.key === "Enter" && inputValue) {
            e.preventDefault(); // Prevent form submission on Enter
            if (!list.includes(inputValue)) {
                setSearchMedicationsList([...list, inputValue]);
                if(!isInputClear){
                    onChange(inputValue);
                }
            }
            setInputValue(""); // Clear input after adding chip
        }
        setIsOpen(true);
        setInputValue(e.target.value);
        handleSearch(e);

    };

    // Handle the input value change
    const handleChange = (e) => {
        setIsOpen(true);
        setInputValue(e?.target?.value ?? e);
        handleSearch(e);
    };

    // Handle search input change
    const handleSearch = (e) => {
        const query = e?.target?.value ?? e;
        setSearchQuery(query);
        setCurrentPage(1); // Reset to page 1 when searching
    };

    // Update displayedData whenever searchQuery or medications data changes
    useEffect(() => {
        let filtered;
        if (searchList?.length > 0) {
            let findSearchList = searchList.map(x => x.answer);
            filtered = findSearchList?.filter((item) =>
                item?.toLowerCase()?.includes(searchQuery.toLowerCase())
            );
        } else {
            filtered = medications?.data?.filter((item) =>
                item.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        setDisplayedData(filtered.slice(0, ITEMS_PER_PAGE)); // Display first 10 matches

        // Reset page to 1 when search query changes
        setCurrentPage(1);
    }, [searchQuery, medications?.data, searchList]); // Dependencies for filtering: searchQuery, medications.data

    // Load more data on scroll
    const loadMore = () => {
        if (loading) return;

        setLoading(true);
        const filteredData = medications?.data?.filter((item) =>
            item.toLowerCase().includes(searchQuery.toLowerCase())
        );
        const nextPageData = filteredData?.slice(currentPage * ITEMS_PER_PAGE, (currentPage + 1) * ITEMS_PER_PAGE);
        setDisplayedData((prevData) => [...prevData, ...nextPageData]); // Append new items

        setCurrentPage((prevPage) => prevPage + 1); // Increment page
        setLoading(false);
    };

    // Detect scroll to bottom
    const handleScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 5) {
            loadMore();
        }
    };

    const handleItemClick = (item) => {
        setIsOpen(false);
        setIsSetDefault(false);
        setSearchMedicationsList([item]);
        isDisabled = true;
        setInputValue("");
        console.log("Selected item:", item);
    };

    const getData = (data) => {
        setTimeout(() => {
            return data;
        }, 1000);
    }

    return (
        <div className="chip-input-container position-relative" ref={inputRef}>
            <div className="input-group">
                <input
                    className="chip-input form-control"
                    type={type}
                    placeholder={placeholderName}
                    value={inputValue}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                />
                {inputValue?.toLowerCase() === 'none'  && (
                    <CheckedImage />
                )}
            </div>
            {/* Display filtered list as dropdown */}
            {isOpen && (
                <div className={`dropdown-list ${displayedData?.length > 0 ? 'active' : ''}`} onScroll={handleScroll}>
                    {displayedData?.map((item, index) => (
                        <div
                            key={index}
                            className="dropdown-item"
                            onClick={() => handleItemClick(item)}
                        >
                            {item} {/* Assuming item is an object with 'name' */}
                        </div>
                    ))}
                </div>
            )}

        </div>
    );
};

export default Chip;
